import React from 'react';
import { makeStyles, AppBar, Tabs, Tab } from '@material-ui/core';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import customAxios from '../../../components/API/customAxios';
import { useIntl } from 'react-intl';
import TabPanel, {a11yProps} from '../../../components/UIComponent/TabPanel';

import SINGLE_TICK from "../assets/single_tick.svg";
import DOUBLE_TICK from "../assets/double_tick.svg";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    employeeName: {
        marginBottom: theme.spacing(2),
    },
    subheader: {
        marginTop: theme.spacing(1),
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    scrollButtons: {
        "& .MuiTabs-scrollButtons.Mui-disabled": { 
            opacity: 0.3 
        },
    },
    image: {
        height: 22,
        verticalAlign: 'middle',
    },
}));

export default function TodayLeave(props: {
    toggle: Boolean,
    targetLeaveDate: String,
}) {
    const classes = useStyles();
    const intl = useIntl();
    const [value, setValue] = React.useState(0);
    const [open, setOpen] = React.useState({});
    const [locations, setLocations] = React.useState([]);
    const [departments, setDepartments] = React.useState([]);
    const [subheader, setSubheader] = React.useState('');
    const [locationId, setLocationId] = React.useState(1);

    React.useEffect(() => {
        customAxios.get('/get_location')
            .then(res => {
                var getLocation = res.data;
                setLocations(getLocation);
            });
    }, []);

    React.useEffect(() => {
        handleGetTodayLeave(locationId);
    }, [props.toggle, props.targetLeaveDate, locationId]);

    const handleChange = (event, newValue) => {
        setLocationId(Number(newValue) + 1);
        setValue(newValue);
    };

    const handleGetTodayLeave = (locationId) => {
        customAxios.get(`/get_today_leave/` + locationId + `?showPending=${props.toggle}&targetLeaveDate=${props.targetLeaveDate}`)
            .then(res => {
                var getTodayLeave = res.data[0];
                var department = res.data[1];
                var openClose = {};

                if (getTodayLeave && getTodayLeave.length > 0 && getTodayLeave[0]['id']) {
                    insertToDepartment(department, getTodayLeave, openClose);
                    // if (Object.keys(open).length === 0) {
                        setOpen({ ...openClose });
                    // }
                    setSubheader(intl.formatMessage({ id: 'table.employee_list' }))
                } else {
                    setDepartments([]);
                    setSubheader(intl.formatMessage({ id: 'home.empty' }))
                }
            })
    }

    const handleClick = (departmentId) => {
        open[departmentId] = !open[departmentId];
        setOpen({ ...open });
    };

    const insertToDepartment = (department, getTodayLeave, openClose) => {
        for (var i = 0; i < getTodayLeave.length; i++) {
            department.map(element => {
                if (!element.children) {
                    element.children = [];
                }
                if (element.id === getTodayLeave[i].department_id) {
                    openClose[element.id] = true
                    element.children.push({
                        id: `${getTodayLeave[i].id}`,
                        name: `${getTodayLeave[i].employee_name}`,
                        position: `${getTodayLeave[i].position}`,
                        location: `${getTodayLeave[i].location}`,
                        department: `${getTodayLeave[i].department}`,
                        start_date: `${getTodayLeave[i].start_date}`,
                        until_date: `${getTodayLeave[i].until_date}`,
                        status: `${getTodayLeave[i].status}`,
                    })
                }
            });
        }
        setDepartments(department);
    }

    return (
        <div className={classes.root}>
            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="on"
                    className={classes.scrollButtons}
                >
                    {locations.map((location, index) => (
                        <Tab key={index} label={location.name} {...a11yProps(location.id)} />
                    ))}
                </Tabs>
            </AppBar>
            {locations.map((location, index) => (
                <TabPanel key={index} value={value} index={index}>
                    <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader" className={classes.subheader}>
                                {subheader}
                            </ListSubheader>
                        }
                        className={classes.root}
                    >
                        {departments.map((department, deIndex) => (
                            <div key={deIndex}>
                                {department.children.length > 0 && ([
                                    <ListItem button onClick={() => handleClick(department.id)} key="1">
                                        <ListItemIcon>
                                            <GroupIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={department.name} />
                                        {open[department.id] ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>,
                                    <Collapse in={open[department.id]} timeout="auto" unmountOnExit key="2">
                                        <List component="div" disablePadding>
                                            {department.children.map((employee, i) => (
                                                <ListItem key={i} button className={classes.nested}>
                                                    <ListItemIcon>
                                                        <PersonIcon />
                                                    </ListItemIcon>
                                                    <ListItemText 
                                                        primary={
                                                                <Typography>
                                                                    {employee.name
                                                                        .replace("(AM)", "(" + intl.formatMessage({ id: 'new_application.AM' }) + ")")
                                                                        .replace("(PM)", "(" + intl.formatMessage({ id: 'new_application.PM' }) + ")")
                                                                        .replace("(Section One)", "(" + intl.formatMessage({ id: 'new_application.Section One' }) + ")")
                                                                        .replace("(Section Two)", "(" + intl.formatMessage({ id: 'new_application.Section Two' }) + ")")
                                                                    }
                                                                    <span>
                                                                        {employee.start_date 
                                                                            ? <>{' '}({employee.start_date} - {employee.until_date})</>
                                                                            : null
                                                                        }
                                                                        {employee.status == 1 
                                                                            ? <img src={SINGLE_TICK} alt="single tick" className={classes.image} />
                                                                            : <img src={DOUBLE_TICK} alt="double tick" className={classes.image} />
                                                                        }
                                                                    </span>
                                                                </Typography>                                         
                                                                }
                                                        secondary={employee.position}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>
                                ])}
                            </div>
                        ))}
                    </List>
                </TabPanel>
            ))}
        </div>
    );
}